import React, { useEffect, useState } from 'react';
import { Line } from "react-chartjs-2";
import {
 Chart,
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Tooltip,
 Legend,
} from "chart.js";

Chart.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, Legend);

const PromotionsStatisticsChart = ({ r_data }) => {
 const [pageData, setPageData] = useState(r_data);

 useEffect(() => {
  setPageData(r_data);
 }, [r_data]);

 const validData = pageData?.valid_entries || [];
 const inValidData = pageData?.invalid_entries || [];


 // 1. Create a sorted union of all dates
 const allDatesSet = new Set([
  ...validData.map(s => s.date),
  ...inValidData.map(s => s.date)
 ]);
 const allDates = Array.from(allDatesSet).sort();

 // 2. Helper to map values by date
 const mapByDate = (dataArray) => {
  const map = {};
  dataArray.forEach(s => {
   map[s.date] = s.count;
  });

  // Map allDates to count or 0/null
  return allDates.map(date => map[date] ?? 0);
 };

 const data = {
  labels: allDates,
  datasets: [
   {
    label: "Valid Data",
    data: mapByDate(validData),
    borderColor: "#2596be",
    backgroundColor: "rgba(0, 153, 255, 0.1)",
    fill: true,
    tension: 0.4
   },
   {
    label: "Invalid Data",
    data: mapByDate(inValidData),
    borderColor: "#eb6459",
    backgroundColor: "rgba(241, 81, 66, 0.1)",
    fill: true,
    tension: 0.4
   }
  ]
 };

 return (
  <Line
   data={data}
   options={{
    plugins: {
     legend: { display: true },
     tooltip: {
      enabled: true,
      callbacks: {
       label: function (context) {
        return context.parsed.y;
       },
      },
     },
    },
    maintainAspectRatio: false,
    scales: {
     y: {
      beginAtZero: true,
      ticks: { color: "#9eaecf", font: { size: 11 }, padding: 10 },
      grid: { color: "rgba(82, 100, 132, 0.2)" }
     },
     x: {
      ticks: { color: "#9eaecf", font: { size: 9 }, padding: 10 },
      grid: { color: "transparent" }
     },
    },
   }}
  />
 );
};

export default PromotionsStatisticsChart;